import React, {Component} from "react";
import Loading from "../Loading";
import Item from "./Item";
import {connect} from "react-redux";
import {getLineWidget} from "../../redux/actions/line";
import lodash from "lodash";

class LineWidget extends Component {
	state = {
		selected : []
	};

	constructor(props) {
		super(props);
		this.selectLeague = this.selectLeague.bind(this);
	}

	componentWillMount() {
		if ( this.props.line.lineWidget.sports.length === 0 ) {
			this.props.onGetLineWidget(0);
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return !(this.props === nextProps && this.state === nextState);
	}

	selectLeague(e) {
		let key = e.target.value;
		let val = e.target.checked;

		this.setState((previous, props) => {
			let data = previous.selected;
			if ( key in data ) {
				delete data[key];
			}
			else {
				data[key] = val;
			}

			return {
				selected : data,
			}
		});
	}

	render() {
		const {lineWidget} = this.props.line;
		const {sports, fetching} = lineWidget;

		const sortedSports = lodash.sortBy(sports, s => s.name);
		const lines = sortedSports.map((sport) =>
			<Item key={`line_${sport.id}`}
			      action={`/line-leagues/${Object.keys(this.state.selected).join("-")}`}
			      sport={sport}
			      selectLeague={this.selectLeague}/>);

		return (
			<ul className="event-list">
				{fetching && <Loading/>}

				{lines}

				{/*<div className="event-list__more buttons">*/}
					{/*<button className="buttons__more">Показать ещё</button>*/}
				{/*</div>*/}
			</ul>
		);
	}
}

export default connect(
	state => ({
		line : state.line
	}),
	dispatch => ({
		onGetLineWidget : (period) => {
			dispatch(getLineWidget(period));
		}
	})
)
(LineWidget);


// WEBPACK FOOTER //
// ./src/app/components/LineWidget/Index.js